import { useCallback, useEffect, useState } from 'react';
import { attachmentsApi } from './attachmentsApi';
import type { Attachment, AttachmentResource } from './types';

export function useAttachments(resourceType: AttachmentResource, resourceId: string) {
  const [items, setItems] = useState<Attachment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!resourceId) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await attachmentsApi.listByResource(resourceType, resourceId);
      setItems(data);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : 'Error al cargar adjuntos');
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [resourceType, resourceId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { items, loading, error, reload };
}
